import { HTTP } from '../../http-common'

export default {
  state: {
    loadedOuterCurtains: []
  },
  getters: {
    loadedOuterCurtains (state) {
      return state.loadedOuterCurtains
    }
  },
  mutations: {
    setLoadedOuterCurtains (state, payload) {
      state.loadedOuterCurtains = payload
    },
    createOuterCurtain (state, payload) {
      state.loadedOuterCurtains.push(payload)
    },
    updateOuterCurtain (state, payload) {
      state.loadedOuterCurtains = state.loadedOuterCurtains.map(outerCurtain => outerCurtain.id === payload.id ? payload : outerCurtain)
    },
    removeOuterCurtain (state, id) {
      state.loadedOuterCurtains = state.loadedOuterCurtains.filter(innerCurtain => {
        return innerCurtain.id !== id
      })
    },
    clearLoadedOuterCurtains (state) {
      state.loadedOuterCurtains = []
    }
  },
  actions: {
    loadOuterCurtains ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedOuterCurtains', [])

      return new Promise((resolve, reject) => {
        HTTP.get('outer_curtain_type.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedOuterCurtains', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createOuterCurtain ({ commit, getters }, payload) {
      console.log('createOuterCurtain')
      commit('clearError')
      commit('setLoading', true)
      const newOuterCurtain = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('outer_curtain_type.json/', newOuterCurtain)
          .then(result => {
            console.log(result)
            commit('createOuterCurtain', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateOuterCurtain ({ commit, getters }, payload) {
      console.log('updateOuterCurtain')
      commit('clearError')
      commit('setLoading', true)
      const outerCurtain = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`outer_curtain_type.json/${payload.id}/`, outerCurtain)
          .then(result => {
            console.log(result)
            commit('updateOuterCurtain', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeOuterCurtain ({ commit }, payload) {
      console.log('removeOuterCurtain')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`outer_curtain_type.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeOuterCurtain', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedOuterCurtains ({ commit }) {
      commit('clearLoadedOuterCurtains')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/outer_curtain/index.js